import { Button, Col, Row } from "antd";
import CategorySvgGray from "../../../../../assets/icons/category-gray.svg";
import TodoSvgGray from "../../../../../assets/icons/todo-icon-gray.svg";
import "../../../../../assets/styles/TD/TD001.css";
import {
  TodoCategoryCode,
  TodoTaskCategoryList,
} from "../../../../../common/components/workflow-todo/entity/Entity";

type TodoListCategoryProps = {
  todoCategoryList: TodoTaskCategoryList;
  categoryIdSelected: string | null;
  checkCategorySelected: (
    currentCategory: number,
    categoryIdSelected: string | null
  ) => boolean;
  onSelectCategory: (id: number) => void;
};

function TodoListCategory({
  todoCategoryList,
  categoryIdSelected,
  checkCategorySelected,
  onSelectCategory,
}: TodoListCategoryProps) {
  const mappingIcons = (itemCode: TodoCategoryCode) => {
    switch (itemCode) {
      case TodoCategoryCode.ProjectTodoTask: {
        return (
          <img
            className="filter-white"
            style={{ width: "24px" }}
            alt=""
            src={CategorySvgGray}
          />
        );
      }
      default:
        return (
          <img
            className="filter-white"
            style={{ width: "24px" }}
            alt=""
            src={TodoSvgGray}
          />
        );
    }
  };

  return (
    <Row gutter={[16, 20]}>
      {todoCategoryList.map((item) => {
        return (
          <Col
            key={item.id}
            span={6}
            style={{ cursor: "pointer" }}
            onClick={() => onSelectCategory(item.id)}
          >
            <div
              className={`header-info-card ${
                checkCategorySelected(item.id, categoryIdSelected)
                  ? "info-card-default"
                  : ""
              }`}
            >
              <Button
                className="header-button-icon"
                size="large"
                icon={mappingIcons(item.code)}
              ></Button>
              <div className="header-content">
                <div className="header-content-number">{item.count}</div>
                <div>{item.description}</div>
              </div>
            </div>
          </Col>
        );
      })}
    </Row>
  );
}

export default TodoListCategory;
